/**
 * MSW inline responses for the carrier CRM (`/apollo/carrier-crm/*`): the registry, and the
 * contacts, notes and significant events that feed the carrier Contacts and Timeline tabs.
 * Spread into the ENV-wide map in `inlineResponses.tsx`.
 */
export const CARRIER_CRM_INLINE_RESPONSES: Record<
  string,
  Record<string, unknown> | unknown[]
> = {
  "/apollo/carrier-crm/carriers": [
    {
      carrierIdentifier: "abf",
      name: "ABF Freight",
      crmStage: "active",
      linearIssueKey: "CAR-12",
    },
    {
      carrierIdentifier: "vankam",
      name: "VanKam Freightways",
      crmStage: "active",
      linearIssueKey: "CAR-138",
    },
    {
      carrierIdentifier: "northern-haul",
      name: "Northern Haul Express",
      crmStage: "prospect",
      linearIssueKey: "CAR-201",
    },
  ],
  "/apollo/carrier-crm/carrier": {
    carrierIdentifier: "abf",
    name: "ABF Freight",
    crmStage: "active",
    crmStageChangedAt: "2024-05-29T00:00:00Z",
    linearIssueKey: "CAR-12",
  },
  "/apollo/carrier-crm/contacts": [
    {
      carrierContactId: "cc-demo-0001",
      name: "Dana Whitfield",
      title: "VP Sales",
      role: "executive",
      seniority: "leadership",
      email: "dana.whitfield@abf.com",
      phone: "+1 604 555 0141",
      isCurrent: true,
      notes: "Our sponsor on the ABF side. Prefers a call over email.",
    },
    {
      carrierContactId: "cc-demo-0002",
      name: "Marcus Lee",
      title: "Pricing Manager",
      role: "pricing",
      seniority: "management",
      email: "mlee@abf.com",
      isCurrent: true,
      notes: "Owns the FAK tariff. Turns pricing requests around in a day.",
    },
    {
      carrierContactId: "cc-demo-0003",
      name: "Priya Raman",
      title: "Account Rep",
      role: "sales_rep",
      seniority: "individual",
      email: "praman@abf.com",
      phone: "+1 604 555 0177",
      isCurrent: true,
    },
    {
      carrierContactId: "cc-demo-0004",
      name: "Nadine Cole",
      title: "Account Rep",
      role: "sales_rep",
      seniority: "individual",
      email: "ncole@abf.com",
      isCurrent: false,
      departedNote:
        "Left in 2025. Was arranging our rate review when she went.",
    },
  ],
  "/apollo/carrier-crm/notes": [
    {
      carrierNoteId: "cn-demo-0001",
      occurredAt: "2026-04-21T15:30:00Z",
      title: "Rate review pushed to Q3",
      body: "Marcus asked to move the annual rate review to July. Their tariff team is tied up with a system migration until then.",
      author: "natasha@freightsimple.com",
      createdBy: "chris@freightsimple.com",
    },
    {
      carrierNoteId: "cn-demo-0002",
      occurredAt: "2025-11-03T18:00:00Z",
      title: "Intro call with Dana",
      body: "Walked through our volume on the Ontario–BC lane. She wants a quarterly check-in.",
      author: "bruno@freightsimple.com",
      createdBy: "chris@freightsimple.com",
    },
  ],
  "/apollo/carrier-crm/significant-events": [
    {
      carrierSignificantEventId: "cse-demo-0001",
      occurredOn: "2026-01-15",
      title: "API quoting live",
    },
    {
      carrierSignificantEventId: "cse-demo-0002",
      occurredOn: "2025-09-01",
      title: "New rate sheet in effect",
    },
  ],
};
